module.exports = __webpack_public_path__ + "static/media/girl.c30b68e0.png";